import ConsultationFluxTab from "@features/stock/components/ConsultationFluxTab";
import { requirePermission } from "@lib/permissions/guards";
import { PERMISSIONS } from "@lib/permissions/permissions.generated";
import { createFileRoute } from "@tanstack/react-router";
import { BarChart3 } from "lucide-react";

export const Route = createFileRoute("/_app/stock/consultation")({
  staticData: {
    title: "Consultation Flux",
    icon: BarChart3,
    tab_icon: BarChart3,
    permission: PERMISSIONS.STOCK.CONSULTATION.VIEW,
    module: "stock",
    section: "Stock",
    order: 50,
    showInTab: true,
    showInNav: true,
    showInBreadcrumb: true,
  },
  loader: requirePermission(PERMISSIONS.STOCK.CONSULTATION.VIEW),
  component: ConsultationFluxTab,
});
